var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHsaBankCustodian)?_c('Review',{on:{"complete":_vm.onStepComplete}}):_c('div',[(!_vm.contactInfoStore.userConfirmedInfo)?_c('DemographicConfirmation'):_c('IdentityChallenge',{on:{"complete":_vm.onStepComplete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }